document.addEventListener('DOMContentLoaded', () => {
	initNewsSliders();
});

function initNewsSliders() {
	const containers = document.querySelectorAll('.cancan-news-slider');
	containers.forEach((container) => {
		initSlider(container);
	});
}

function initSlider(container) {
	try {
		const slideCount = container.querySelectorAll('.swiper-slide').length;
		const wrapper =
			container.closest('.news-slider-wrapper') ||
			container.parentElement;

		// Determine slidesPerView for current viewport
		const width = window.innerWidth;
		let currentSlidesPerView = 1;
		if (width >= 1524) currentSlidesPerView = 4;
		else if (width >= 1124) currentSlidesPerView = 3;
		else if (width >= 768) currentSlidesPerView = 2;

		// Loop requires more slides than slidesPerView
		const canLoop = slideCount > currentSlidesPerView;

		const swiperInstance = new Swiper(container, {
			spaceBetween: 40,
			slidesPerView: 1,
			grabCursor: true,
			loop: canLoop,
			breakpoints: {
				768: { slidesPerView: 2 },
				1124: { slidesPerView: 3 },
				1524: { slidesPerView: 4 },
			},
			navigation: {
				prevEl: container.querySelector('.swiper-button-prev'),
				nextEl: container.querySelector('.swiper-button-next'),
			},
			autoplay: {
				delay: 3000,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
			},
		});
	} catch (error) {
		console.error('Error initializing Swiper:', error);
	}
}
